import { render } from "./ImportContactsClientModal.vue?vue&type=template&id=9688c596&scoped=true"
import script from "./ImportContactsClientModal.vue?vue&type=script&lang=js"
export * from "./ImportContactsClientModal.vue?vue&type=script&lang=js"

import "./ImportContactsClientModal.vue?vue&type=style&index=0&id=9688c596&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-clients\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9688c596"]])

export default __exports__